import { ComponentPropsWithoutRef, useState } from 'react'
import { DocumentIcon } from '~shared/icons/document'
import Image from 'next/image'
import { LeadForm } from './lead-form'
import { SuccessViewBoundary } from './success-view'

// import { FolderIcon } from './folder-icon'
// import { FolderDecoration } from './folder-decoration'

type PdfFile = {
  name?: string
  url?: string
}

interface FilesCollectionProps extends ComponentPropsWithoutRef<'section'> {
  pdf?: PdfFile[]
  faculty?: string
}

export const FilesCollection = ({
  pdf,
  faculty,
  className = '',
  ...props
}: FilesCollectionProps) => {
  const [isSuccess, setIsSuccess] = useState(false)

  return (
    <section className={className} {...props}>
      <SuccessViewBoundary isSuccess={isSuccess}>
        <div className='relative overflow-hidden rounded-[24px] bg-secondary p-4 md:p-6 lg:p-8'>
          <Image
            src='/assets/imgs/journal-page/books.png'
            width={200}
            height={200}
            alt='Книги МИТМ'
            className='object-cover absolute top-0 right-0 w-[200px] hidden md:block'
          />
          <div className='relative z-10'>
            <h2 className='font-medium leading-[120%] text-2xl md:text-3xl lg:text-4xl '>
              Получите подборку полезных материалов
            </h2>
            {!!pdf?.length && (
              <div className='mt-7 flex flex-col gap-4'>
                {pdf.map(
                  ({ name }, idx) =>
                    name && (
                      <div
                        key={`${name}-${idx}`}
                        className='flex items-center gap-2 text-white'>
                        <DocumentIcon className='w-[24px] h-[24px]' />
                        <span className='text-sm text-[#8B8B8B]'>{name}</span>
                      </div>
                    )
                )}
              </div>
            )}
            <LeadForm
              className='mt-8'
              formanaim='Новости МИТМ'
              buttonText='Получить файлы'
              onSuccess={() => setIsSuccess(true)}
              pdfData={
                pdf?.filter(p => p.name && p.url) as {
                  name: string
                  url: string
                }[]
              }
            />
          </div>
        </div>
      </SuccessViewBoundary>
    </section>
  )
}
